import React, { FC, useEffect, useState } from 'react';

import {
  FormControl as ChakraFormControl,
  Input as ChakraInput,
  Text as ChakraText,
  forwardRef,
  useMultiStyleConfig,
} from '@chakra-ui/react';

import { ComponentReceivedProps } from '@types';

import { DateInputProps, DateInputTriggers } from './index';
import { defaultProps } from './protocol';

export const component: FC<ComponentReceivedProps<DateInputProps, DateInputTriggers>> = forwardRef(
  ({ props = defaultProps, triggers }, ref) => {
    const { label, size, value, ...rest } = props;
    const { onBlur } = triggers;

    const [state, setState] = useState(value);

    const baseInputStyles = useMultiStyleConfig('PTBaseInput', { size });

    useEffect(() => {
      setState(value);
    }, [value]);

    return (
      <ChakraFormControl>
        {label && <ChakraText sx={baseInputStyles['base-input-label'] || {}}>{label}</ChakraText>}
        <ChakraInput
          {...rest}
          type="datetime-local"
          sx={baseInputStyles['base-input-control'] || {}}
          ref={ref}
          value={state}
          onBlur={({ target }) => onBlur && onBlur(target.value)}
          onChange={({ target }) => setState(target.value)}
        />
      </ChakraFormControl>
    );
  },
);
